module.exports = __webpack_public_path__ + "img/image-user-up.6e75f7d2.svg";